const nextAPIRoutes = {
  SIGNUP: "/api/signup",
  TOKEN: "/api/token",
  LOGOUT: "/api/logout",
  CHECK_AVAILABILITY: "/api/user/available",
  OTP_VERIFICATION: "/api/user/otp",
  VERIFY_OTP: "/api/user/verify-otp",
  GET_PROFILE: "/api/user/get-profile",
  UPDATE_PROFILE: "/api/user/update-profile",

  MANUFACTURER: "/api/manufacturer",
  MANUFACTURER_MODELS: "/api/manufacturer-models",
  ATTACHMENTS: "/api/attachments",

  DRAFT_LISTING: "/api/listing/draft",
  SAVE_LISTING: "/api/listing/save",
  LISTING_DETAILS: "/api/listing/details",

  CONFIG_TRACTOR: "/api/save-tractor-config",

  SAVE_IMAGES: "/api/images/save",
  GET_IMAGES: "/api/images/fetch",
  REMOVE_IMAGE: "/api/images/remove",

  ADD_ADDRESS: "/api/address/add",
  FETCH_ADDRESS: "/api/address/fetch",

  DASHBOARD_LISTING: "/api/dashboard/listing",
  OWNER_DASHBOARD: "/api/dashboard/owner-dashboard",

  GET_PRICING_ASSETS: "/api/pricing-items",

  SEARCH_LISTING: "/api/search",
  SEARCH_DETAILS: "/api/search/listing-details",

  ADD_ITEM_TO_CART: "/api/cart/add",
  FETCH_CART: "/api/cart/fetch",
  UPDATE_CART_ITEM: "/api/cart/update",
  REMOVE_CART_ITEM: "/api/cart/remove",
  UPDATE_DELV_TYPE: "/api/cart/update-delv-type",

  USER_CONFIG_SAVE: "/api/user/config",
  USER_CONFIG_FETCH: "/api/user/fetch",

  FETCH_INSURANCE: "/api/insurance/fetch",

  ADD_DELIVERY_ADDRESS: "/api/delivery-address/add",
  GET_DELVERY_ADDRESS: "/api/delivery-address/fetch",

  CREATE_BOOKING: "/api/booking/create",
  LIST_BOOKING: "/api/booking/fetch",
  UPDATE_BOOKING_STATUS: "/api/booking/update-status",
  COMPLETE_BOOKING_PAYMENT: "/api/booking/complete-payment",
  UPLOAD_BOOKING_DOCS: "/api/booking/upload-documents",
  SUGGEST_DATE_CHANGES: "/api/booking/suggest-dates",
  SAVE_DATE_CHANGES: "/api/booking/save-suggest-dates",

  CARD_FETCH: "/api/card/fetch",
  CARD_CREATE: "/api/card/create",
  CARD_DELETE: "/api/card/remove",
  CARD_DEFAULT: "/api/card/make-default",

  GET_NOTIFICATIONS: "/api/notification/fetch",
  MARK_READ_NOTIFICATIONS: "/api/notification/read",
  MARK_READALL_NOTIFICATIONS: "/api/notification/read-all",
};

const apiServerRoutes = {
  SIGNUP: "/user/create",
  AUTH_TOKEN: "/user/authToken",
  CHECK_AVAILABILITY: "/user/status/available",
  OTP_VERIFICATION: "/user/otp",
  VERIFY_OTP: "/user/otp/verify",
  GET_PROFILE: "/user/profile",
  UPDATE_PROFILE: "/user/profile",

  MANUFACTURER: "/manufacturer/listAll",
  MANUFACTURER_MODELS: "/manufacturer/:id/models",
  ATTACHMENTS: "/attachment/listAll",

  DRAFT_LISTING: "/listing/draft",
  SAVE_LISTING: "/listing/:id",
  LISTING_DETAILS: "/listing/:id",

  CONFIG_TRACTOR: "/tractor/:id/create/config",

  SAVE_IMAGES: "/images/save",
  GET_IMAGES: "/images/:id",
  REMOVE_IMAGE: "/images/:id",

  ADD_ADDRESS: "/address",
  FETCH_ADDRESS: "/address",
  DEFAULT_ADDRESS: "/address/default",

  DASHBOARD_LISTING: "/dashboard/listing/:type",
  OWNER_DASHBOARD: "/dashboard/owner",
  OWNER_DASHBOARD_STATS: "/dashboard/stats",
  OWNER_DASHBOARD_BOOKINGS: "/dashboard/bookings",
  OWNER_DASHBOARD_PAYOUTS: "/user/payouts",
  DELETE_EQUIPMENT: "/listing/:id",

  GET_PRICING_ASSETS: "/pricing/assets",

  SEARCH_LISTING: "/search?",
  SEARCH_DETAILS: "/search/listing/:id",
  SEARCH_DETAILS_OWNER: "/listing/:id",

  ADD_ITEM_TO_CART: "/cart/addItem",
  FETCH_CART: "/cart/listCartItems",
  UPDATE_CART_ITEM: "/cart/editItem/:id",
  REMOVE_CART_ITEM: "/cart/deleteItem/:id",
  UPDATE_DELV_TYPE: "/cart/changeDeliveryType",

  USER_CONFIG_SAVE: "/user/config",
  USER_CONFIG_FETCH: "/user/config",

  FETCH_INSURANCE: "/insurance",

  ADD_DELVERY_ADDRESS: "/delivery-address",
  GET_DELVERY_ADDRESS: "/delivery-address",

  CREATE_BOOKING: "/booking/create",
  LIST_BOOKING: "/booking/listAll",
  BOOKING_DETAILS: "/booking/:id",
  UPDATE_BOOKING_STATUS: "/booking/:id/changeStatus",
  COMPLETE_BOOKING_PAYMENT: "/booking/:id/completePayment",
  UPLOAD_BOOKING_DOCS: "/booking/:id/documents",
  SUGGEST_DATE_CHANGES: "/booking/:id/suggestDateChange",
  SAVE_DATE_CHANGES: "/booking/:id/confirmDateChange",

  CARD_FETCH: "/user-card",
  CARD_CREATE: "/user-card",
  CARD_DELETE: "/user-card/:id",
  CARD_DEFAULT: "/user-card/default/:id",

  GET_NOTIFICATIONS: "/user-notification",
  MARK_READ_NOTIFICATIONS: "/user-notification/markRead/:id",
  MARK_READALL_NOTIFICATIONS: "/user-notification/clearAll",

  CHECK_RESET_TOKEN: "/reset-token/check",
  SET_RESET_TOKEN: "/reset-token/save",

  REACH_US: "/user/submit_enquiry",
  DOCUMENTS: "/booking/documents",
};
export { nextAPIRoutes, apiServerRoutes };
